module.exports = __webpack_public_path__ + "img/newNepa.9b94fd4f.svg";